module.exports = [
  'Licensed Clinical Social Worker (LCSW)',
  'Licensed Professional Counselor (LPC)',
  'Licensed Marriage and Family Therapist (LMFT)',
  'Licensed Mental Health Counselor (LMHC)',
  'Licensed Clinical Professional Counselor (LCPC)',
  'Licensed and Independent Clinical Social Worker (LICSW)',
];
